import mixpanel from 'mixpanel-browser';

/**
 * An function that sends an event to mixpanel
 */
function sendMixpanelEvent(events) {
    if (!mixpanel.config) {
        // Mixpanel disabled 1/2, this is a no-op
        return;
    }

    events.forEach((event) => {
        const { hitType, ...eventProps } = event;

        switch (hitType) {
        case 'identify':
            {
                const { userId, ...props } = eventProps;
                mixpanel.identify(userId);
                mixpanel.people.set(props);
            }
            break;
        case 'pageview':
            {
                const { page, ...props } = eventProps;
                mixpanel.track(page, props);
            }
            break;
        case 'event':
            {
                const { eventAction, ...props } = eventProps;
                mixpanel.track(eventAction, props);
            }
            break;
        case 'alias': // Untested
            mixpanel.alias(event.userId);
            break;
        default:
            break;
        }
    });
}

module.exports = {
    MixpanelAnalytics: sendMixpanelEvent,
};



// WEBPACK FOOTER //
// ./src/tracking/mixpanelBeconTarget.js